/**
 * Generic hub batch-selection mode registry.
 *
 * Modules define one mode per filter key. Only modes with `enabled: true`
 * activate selection UI; `actions` describe available batch operations.
 */

/**
 * @typedef {Object} HubBatchActionDefinition
 * @property {string} id
 * @property {(selectedCount: number) => string} label
 * @property {boolean} [destructive]
 */

/**
 * @typedef {Object} HubBatchModeDefinition
 * @property {boolean} enabled
 * @property {HubBatchActionDefinition[]} actions
 */

/**
 * @param {{ enabled: boolean, actions?: HubBatchActionDefinition[] }} config
 * @returns {HubBatchModeDefinition}
 */
export function createHubBatchMode({ enabled, actions = [] }) {
  return { enabled, actions };
}

/**
 * @param {Record<string, HubBatchModeDefinition>} modes
 * @param {string|null|undefined} filterKey
 * @returns {HubBatchModeDefinition|null}
 */
export function resolveHubBatchMode(modes, filterKey) {
  if (!filterKey) return null;

  const mode = modes[filterKey];
  if (!mode?.enabled) return null;

  return mode;
}

/**
 * @param {HubBatchModeDefinition|null} mode
 * @param {string} actionId
 * @returns {HubBatchActionDefinition|null}
 */
export function findHubBatchAction(mode, actionId) {
  if (!mode) return null;
  return mode.actions.find((action) => action.id === actionId) || null;
}
